import React from 'react'
import { FormGroup, Label } from "reactstrap"

const FilterStore = ({nameSpace, handleChangeName}) => {

    let _timeOut = null

    const _handleChange = e => {
        const { value } = e.target

        if (_timeOut) clearTimeout(_timeOut)

        _timeOut = setTimeout(() => {
            handleChangeName(value)
        }, 500)
    }
    return (
        <div className='FilterStore'>
            <FormGroup>
                <Label className='font-weight-bold'>Store</Label>
                <input
                    type='text'
                    name='name'
                    placeholder='Nhập namespace...'
                    onChange={_handleChange}
                    className="ant-input"
                />
            </FormGroup>
        </div>
    )
}

export default FilterStore